import React, { useEffect, useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
// import {
//   MaterialReactTable,
//   useMaterialReactTable,
// } from "material-react-table";
import {
  useMaterialReactTable,
  MRT_ToggleFiltersButton,
  MRT_ShowHideColumnsButton,
  MRT_TableContainer,
} from 'material-react-table';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { API_URL } from "../../env";
import { CustomStringify } from "../../Helpers/CustomStringify";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataPKRep } from "../../Redux/ReportsData/PackingChallanReportDataSlice";

import dayjs from "dayjs";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, parse } from "date-fns";
import { enGB } from "date-fns/locale";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsLeftRight } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
config.autoAddCss = false;

const fontAwesomeIcons = {
  DragHandleIcon: () => (
    <FontAwesomeIcon
      icon={faArrowsLeftRight}
      style={{ paddingLeft: "5px", fontSize: "14px", color: "white" }}
    />
  ),
};

export default function PackingChallanReport() {
  const Theme = useSelector((state) => state.Theme);
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);
  const { result, status, error } = useSelector(
    (state) => state.PackingChallanReportData
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [Loader, setLoader] = useState(false);
  const [PackingChallanReportData, setPackingChallanReportData] = useState([]);
  const [MergedData, setMergedData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleExport = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const form = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "15px",
            height: "32px",
            width: "150px",
            background: "#fff",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            marginTop: "-10px",
          },
        },
      },
    },
  });

  const insertHiddenColmns = async () => {
    setLoader(true);
    var myHeaders = new Headers();
    const Token = localStorage.getItem("token");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append("Authorization", `Bearer ${Token}`);

    let positionObj = {};
    columnOrder?.map((item, index) => (positionObj[item] = index));

    var raw = CustomStringify({
      Hidd_Clm: columnVisibility,
      position: positionObj,
      Server: {
        Database: cmpdetail?.Database,
        Password: cmpdetail?.Password,
        Server: cmpdetail?.Server,
        User_ID: cmpdetail?.User_ID,
        Port: cmpdetail?.Port,
      },
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${API_URL}/SlBRpt_InsertHiddenClm`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status === true) {
          setLoader(false);
          showToast("Saved Successfully", "success");
        } else {
          setLoader(false);
          showToast(result?.message, "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        showToast("API Error", "error");
        console.log(error);
      });
  };

  const exportToExcel = (rows) => {
    let ReorderedColumns = table
      .getState()
      .columnOrder?.map((columnId) => table.getColumn(columnId)?.columnDef);

    const tableData = rows?.map((row) =>
      Object.values(
        ReorderedColumns?.filter((item) => columnVisibility[item?.id]).reduce(
          (acc, c) => {
            if (c.id?.includes("Date")) {
              acc[c.id] =
                new Date(row.original[c.id])?.toLocaleDateString("en-GB") ==
                  "01/01/1"
                  ? ""
                  : new Date(row.original[c.id])?.toLocaleDateString("en-GB");
            } else {
              acc[c.id] = row.original[c.id];
            }
            return acc;
          },
          {}
        )
      )
    );
    const tableHeaders = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) => c.header);

    const tableRows = tableData?.map((row) =>
      row?.map((value) => value).join(",")
    );

    const csvData = [tableHeaders.join(","), ...tableRows].join("\n");

    const blob = new Blob([csvData], { type: "text/csv" });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Packing_Challan_Report.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportToPDF = (rows) => {
    const doc = new jsPDF({ orientation: "landscape" });
    const xOffset = doc.internal.pageSize.width / 2;
    doc.setFontSize(12);
    doc.text(cmpdetail?.company_name ?? "", xOffset, 8, { align: "center" });
    doc.setFontSize(10);
    doc.text("Packing challan Report", xOffset, 12, { align: "center" });

    let ReorderedColumns = table.getState().columnOrder?.map((columnId) => table.getColumn(columnId)?.columnDef);

    const tableData = rows?.map((row) =>
      Object.values(
        ReorderedColumns?.filter((item) => columnVisibility[item?.id]).reduce(
          (acc, c) => {
            if (c.id?.includes("Date")) {
              acc[c.id] =
                new Date(row.original[c.id])?.toLocaleDateString("en-GB") == "01/01/1"
                  ? ""
                  : new Date(row.original[c.id])?.toLocaleDateString("en-GB");
            } else {
              acc[c.id] = row.original[c.id] ?? "";
            }
            return acc;
          }, {}
        )
      )
    );

    const tableHeaders = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) => c.header ?? "");

    const tableFooters = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) => {
      try {
        const footerContent = c?.Footer?.();
        const textValue = footerContent?.props?.children ?? "";
        return (typeof textValue === 'string' || typeof textValue === 'number') ? textValue : "";
      } catch {
        return "";
      }
    });

    autoTable(doc, {
      head: [tableHeaders],
      body: tableData,
      foot: [tableFooters],
      showHead: "firstPage",
      showFoot: "lastPage",
      theme: "striped",
      columnStyles: { text: { cellWidth: "auto" } },
      margin: { left: 3, right: 3 },
      styles: {
        overflow: "linebreak",
        cellWidth: "wrap",
        cellPadding: 1,
        fontSize: 6,
      },
      autoWidth: true,
    });

    doc.save("Packing_Challan_Report.pdf");
  };


  const exportToJson = () => {
    const json = CustomStringify(FilteredData, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Packing_Challan_Report.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  const [columnVisibility, setColumnVisibility] = useState({
    bill_no: true,
    bill_date: true,
    supply_design: true,
    design_no: true,
    product: true,
    hsn_code: true,
    design_qty: true,
    rate: true,
    totalAmount: true,
    gst_amount: true,
    net_amount: true,
    transport: true,
  });
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);

  const columns = [
    {
      accessorKey: "bill_no",
      header: "Bill No.",
      size: 50,
      Footer: () => {
        return (
          <span style={{ fontSize: "15px", fontWeight: "bold" }}>Total</span>
        );
      },
    },
    {
      accessorFn: (originalRow) => new Date(originalRow.bill_date),
      id: "bill_date",
      header: "Bill Date",
      size: 50,
      filterFn: (row, columnId, filterValue) => {
        const { startDate, endDate } = filterValue;

        return startDate && !endDate
          ? row.getValue(columnId) >= startDate
          : !startDate && endDate
            ? row.getValue(columnId) <= endDate
            : startDate && endDate
              ? row.getValue(columnId) >= startDate &&
              row.getValue(columnId) <= endDate
              : row.getValue(columnId);
      },
      Filter: ({ column, table }) => {
        const handleFilterChange = (startDate, endDate) => {
          table.setColumnFilters([
            {
              id: column.id,
              value: {
                startDate: startDate ? dayjs(startDate) : null,
                endDate: endDate ? dayjs(endDate) : null,
              },
            },
          ]);
        };

        return (
          <ThemeProvider theme={form}>
            <LocalizationProvider dateAdapter={AdapterDayjs} locale={enGB}>
              <div style={{ display: "flex", gap: "1rem" }}>
                <DatePicker
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { placeholder: "Start Date" } }}
                  value={column.getFilterValue()?.startDate}
                  onChange={(newValue) =>
                    handleFilterChange(
                      newValue.format("YYYY-MM-DD"),
                      column.getFilterValue()?.endDate
                    )
                  }
                  renderInput={(params) => <TextField {...params} />}
                />
                <DatePicker
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { placeholder: "End Date" } }}
                  value={column.getFilterValue()?.endDate}
                  onChange={(newValue) =>
                    handleFilterChange(
                      column.getFilterValue()?.startDate,
                      newValue.format("YYYY-MM-DD")
                    )
                  }
                  renderInput={(params) => <TextField {...params} />}
                />
              </div>
            </LocalizationProvider>
          </ThemeProvider>
        );
      },
      Cell: ({ cell }) =>
        cell.getValue().toLocaleDateString("en-GB") == "01/01/1"
          ? ""
          : cell.getValue().toLocaleDateString("en-GB"),
    },
    {
      accessorKey: "supply_design",
      header: "Supply Design",
      size: 50,
    },
    {
      accessorKey: "design_no",
      header: "Design",
      size: 50,
    },
    {
      accessorKey: "product",
      header: "Product",
      size: 50,
    },
    {
      accessorKey: "hsn_code",
      header: "HSN Code",
      size: 50,
    },
    {
      accessorKey: "design_qty",
      header: "Qty",
      size: 50,
      Footer: () => {
        const TotValue = FilteredData?.reduce(
          (acc, item) => acc + Number(item.design_qty),
          0
        );
        return (
          <span style={{ fontSize: "15px", fontWeight: "bold" }}>
            {TotValue?.toFixed(2)}
          </span>
        );
      },
    },
    {
      accessorKey: "rate",
      header: "Rate",
      size: 50,
    },
    {
      accessorKey: "totalAmount",
      header: "Amount BFT",
      size: 50,
      Footer: () => {
        const TotValue = FilteredData?.reduce(
          (acc, item) => acc + Number(item.totalAmount),
          0
        );
        return (
          <span style={{ fontSize: "15px", fontWeight: "bold" }}>
            {TotValue?.toFixed(2)}
          </span>
        );
      },
    },
    {
      accessorKey: "gst_amount",
      header: "GST Amt",
      size: 50,
      Footer: () => {
        const TotValue = FilteredData?.reduce(
          (acc, item) => acc + Number(item.gst_amount),
          0
        );
        return (
          <span style={{ fontSize: "15px", fontWeight: "bold" }}>
            {TotValue?.toFixed(2)}
          </span>
        );
      },
    },
    {
      accessorKey: "net_amount",
      header: "Total Amt",
      size: 50,
      Footer: () => {
        const TotValue = FilteredData?.reduce(
          (acc, item) => acc + Number(item.net_amount),
          0
        );
        return (
          <span style={{ fontSize: "15px", fontWeight: "bold" }}>
            {TotValue?.toFixed(2)}
          </span>
        );
      },
    },
    {
      accessorKey: "transport",
      header: "Transport",
      size: 50,
    },
  ];

  const data = MergedData;

  const table = useMaterialReactTable({
    columns,
    data,
    icons: fontAwesomeIcons,
    enableColumnOrdering: true,
    enableBottomToolbar: false,
    enablePagination: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    // columnFilterDisplayMode: 'popover',
    enableSorting: false,
    enableGlobalFilter: false,
    initialState: { density: "compact" },
    muiTableContainerProps: {
      sx: {
        maxHeight: `calc(${"100vh"} - ${"100px"})`,
        "@media (max-width: 768px)": {
          maxHeight: `calc(${"100vh"} - ${"140px"})`,
        },
      }
    },
    muiTableHeadCellProps: {
      sx: {
        bgcolor: Theme.primaryThemeColor,
        color: "#fff",
        "@media (max-width: 768px)": {
          padding: "2px 16px"
        },
      },
    },
    muiTableBodyCellProps: {
      sx: {
        opacity: 0.9,
        border: "1px solid grey",
        "@media (max-width: 768px)": {
          fontSize: "13px",
          padding: "2px 16px"
        },
      },
    },
    muiTableFooterCellProps: {
      sx: {
        bgcolor: Theme.primaryThemeColor,
        color: "#fff",
        paddingTop: "2px",
        paddingBottom: "2px",
      },
    },
    muiColumnActionsButtonProps: {
      sx: {
        color: "#fff",
      },
    },
    muiFilterTextFieldProps: {
      placeholder: "Filter",
      sx: {
        background: "#fff",
        borderRadius: "5px",
        padding: "0px 3px",
      },
    },
    state: { columnVisibility, columnOrder, columnFilters },
    onColumnVisibilityChange: (state) => {
      return setColumnVisibility(state);
    },
    onColumnOrderChange: (state) => {
      return setColumnOrder(state);
    },
    onColumnFiltersChange: (state) => {
      return setColumnFilters(state);
    }
  });

  useEffect(() => {
    const mergedArray = PackingChallanReportData?.reduce((accumulator, current) => {
      const existing = accumulator.find(
        (item) =>
          (columnVisibility.bill_no
            ? item.bill_no === current.bill_no
            : true) &&
          (columnVisibility.bill_date
            ? item.bill_date === current.bill_date
            : true) &&
          (columnVisibility.supply_design
            ? item.supply_design === current.supply_design
            : true) &&
          (columnVisibility.design_no
            ? item.design_no === current.design_no
            : true) &&
          (columnVisibility.product
            ? item.product === current.product
            : true) &&
          (columnVisibility.hsn_code
            ? item.hsn_code === current.hsn_code
            : true) &&
          (columnVisibility.rate
            ? item.rate === current.rate
            : true) &&
          (columnVisibility.transport
            ? item.transport === current.transport
            : true)
      );

      if (existing) {
        existing.design_qty += current.design_qty;
        existing.totalAmount += current.totalAmount;
        existing.gst_amount += current.gst_amount;
        existing.net_amount += current.net_amount;
      } else {
        accumulator.push({ ...current });
      }

      return accumulator;
    }, []);
    setMergedData(mergedArray);
  }, [columnVisibility, PackingChallanReportData]);

  useEffect(() => {
    const filteredRows = table.getFilteredRowModel().rows;
    const filteredData = filteredRows?.map((row) => row.original);
    setFilteredData(filteredData);
  }, [columnFilters]);

  useEffect(() => {
    dispatch(fetchDataPKRep({ cmpdetail: cmpdetail, UserDetail: UserDetail }));
  }, []);

  useEffect(() => {
    if (status === "loading") {
      setLoader(true);
    }
    else if (status === "succeeded") {
      setLoader(false);
      let Data = result?.data?.map((item) => {
        return {
          ...item,
          design_qty: item?.design_qty ? Number(item?.design_qty).toFixed(2) : "",
          totalAmount: item?.totalAmount ? Number(item?.totalAmount).toFixed(2) : "",
          gst_amount: item?.gst_amount ? Number(item?.gst_amount).toFixed(2) : "",
          net_amount: item?.net_amount ? Number(item?.net_amount).toFixed(2) : "",
          bill_date: item?.bill_date?.replace(/\.\d{3}Z$/, "")
        };
      });
      setPackingChallanReportData(Data);
      setMergedData(Data);
      setFilteredData(Data);

      // let sanitisedResult = (result) => {
      //   let obj = { ...result };
      //   delete obj.$id;
      //   delete obj.SLBDtl_SetId;
      //   return obj;
      // }
      // setColumnVisibility(sanitisedResult(result?.data[0]?.HiddenColumns));
      // let positionObj = sanitisedResult(result?.data[0]?.HiddenColumnPosition);
      // let positionArr = Object.keys(positionObj).sort(
      //   (a, b) => positionObj[a] - positionObj[b]
      // );
      // setColumnOrder(positionArr);
    } else if (status === "failed") {
      setLoader(false);
    }
  }, [status]);

  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h4: {
        fontWeight: "500",
        fontSize: "20px",
        "@media (max-width: 768px)": {
          fontSize: "16px",
        },
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            maxWidth: "260px",
            height: "28px",
            padding: "12px 8px 12px 8px",
            fontWeight: 500,
            "@media (max-width: 768px)": {
              fontSize: "11px",
              padding: "10px 5px 10px 5px",
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            fontSize: "15px",
            "@media (max-width: 768px)": {
              fontSize: "13px",
            },
          },
        },
      },
    },
  });

  return (
    <>
      <div
        className="main-box"
        style={{ paddingTop: "10px", paddingBottom: "10px" }}
      >
        <ThemeProvider theme={theme}>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={Loader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <div className="box-head-report">
            <Stack alignItems="center" direction="row">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(`/CompanyDashboard`);
                }}
              >
                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
              </IconButton>
              <Typography variant="h4">Packing challan Report</Typography>
            </Stack>
            <Stack className="btns" alignItems="center" direction="row">
              {/* <Button onClick={insertHiddenColmns} variant="contained">
                <ViewWeekIcon sx={{ mr: 1, fontSize: "16px" }} /> Save Template
              </Button> */}
              <Button onClick={handleExport} variant="contained">
                <SaveAltIcon sx={{ fontSize: "16px" }} />
              </Button>
              <MRT_ToggleFiltersButton table={table} />
              <MRT_ShowHideColumnsButton table={table} />
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => (
                    exportToExcel(table.getPrePaginationRowModel().rows),
                    handleClose()
                  )}
                >
                  Download Excel
                </MenuItem>
                <MenuItem
                  onClick={() => (
                    exportToPDF(table.getPrePaginationRowModel().rows), handleClose()
                  )}
                >
                  Download PDF
                </MenuItem>
                <MenuItem onClick={() => (exportToJson(), handleClose())}>
                  Download JSON
                </MenuItem>
              </Menu>
            </Stack>
          </div>
          <MRT_TableContainer table={table} />
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MaterialReactTable table={table} />
          </LocalizationProvider> */}
        </ThemeProvider>
      </div>

      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
